let ethnicityTooltipTimeout;

export const showEthnicityCustomTooltips = (tooltipModel, thisChart, imageList, ethnicityList: { [eth: string]: string }) => {

  window.clearTimeout(ethnicityTooltipTimeout);

  // Tooltip Element
  let tooltipEl = document.getElementById('ethnicity-chartjs-tooltip');

  // Create element on first render
  if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'ethnicity-chartjs-tooltip';
      tooltipEl.innerHTML = '<table style="margin-left: 10px; margin-top: 5px;"></table><div></div>';
      document.body.appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltipModel.opacity === 0) {
    window.clearTimeout(ethnicityTooltipTimeout);
    tooltipEl.style.opacity = '0';
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
  } else {
      tooltipEl.classList.add('no-transform');
  }

  // function getBody(bodyItem) {
  //   return bodyItem.lines;
  // }

  const chartDatasets = thisChart._data.datasets;
  const chartLabels = thisChart._data.labels;
  let activeEthnicityClass;
  let activeGenderLabel;
  // Set Text
  if (tooltipModel.body) {
    const titleLines = tooltipModel.title || [];
    // var bodyLines = tooltipModel.body.map(getBody);
    const bodyLines = tooltipModel.dataPoints.map((datapoint) => {
      const rawValue = chartDatasets[datapoint.datasetIndex].data[datapoint.index].toLocaleString();
      const genderLabel = chartDatasets[datapoint.datasetIndex].label;
      const ethnicityLabel = chartLabels[datapoint.index];
      activeGenderLabel = genderLabel;
      activeEthnicityClass = Object.keys(ethnicityList).find(eth => typeof ethnicityLabel === 'string' ? ethnicityList[eth] === ethnicityLabel : (ethnicityLabel as string[]).includes(ethnicityList[eth]));
      return `${genderLabel}: ${rawValue}`;
    });

    let innerHtml = '<thead>';

    titleLines.forEach((title) => {
      innerHtml += '<tr><th>' + title + '</th></tr>';
    });
    innerHtml += '</thead><tbody>';

    bodyLines.forEach((body, i) => {
      const colors = tooltipModel.labelColors[i];
      let style = 'background:' + colors.backgroundColor;
      style += '; border-color:' + colors.borderColor;
      style += '; border-width: 2px';
      style += '; display: inline-block';
      style += '; width: 15px';
      style += '; height: 15px';
      style += '; margin-right: 5px';
      style += '; vertical-align: middle';
      const span = '<span style="' + style + '"></span>';
      innerHtml += '<tr><td>' + span + body + '</td></tr>';
    });
    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');
    tableRoot.innerHTML = innerHtml;
  }

  const imageRoot = tooltipEl.querySelector('div');
  const ethnicityImageSrc_1 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[0] || '../assets/image/placeholder.png';
  const ethnicityImageSrc_2 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[1] || '../assets/image/placeholder.png';
  const ethnicityImageSrc_3 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[2] || '../assets/image/placeholder.png';
  const ethnicityImageSrc_4 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[3] || '../assets/image/placeholder.png';
  const ethnicityImageSrc_5 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[4] || '../assets/image/placeholder.png';
  const ethnicityImageSrc_6 = imageList?.[activeGenderLabel]?.[activeEthnicityClass]?.[5] || '../assets/image/placeholder.png';

  imageRoot.innerHTML = `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_1}"></img>` +
  `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_2}"></img>` +
  `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_3}"></img>` +
  `<br/>` +
  `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_4}"></img>` +
  `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_5}"></img>` +
  `<img style="width: 50px; height: 50px; margin: 5px 5px;" src="${ethnicityImageSrc_6}"></img>`;

  // `this` will be the overall tooltip
  const position = thisChart._chart.canvas.getBoundingClientRect();

  // Display, position, and set styles for font
  tooltipEl.style.opacity = '1';
  tooltipEl.style.position = 'absolute';
  // tooltipEl.style.left = (position.left + window.pageXOffset + tooltipModel.caretX ) + 'px';
  // tooltipEl.style.top = (position.top + window.pageYOffset + tooltipModel.caretY - 100) + 'px';
  tooltipEl.style.left = (position.left + 100) + 'px';
  tooltipEl.style.top = (position.top + window.pageYOffset) + 'px';
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
  tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
  tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
  tooltipEl.style.pointerEvents = 'none';
  tooltipEl.style.backgroundColor = 'rgba(0,0,0, 0.8)';
  tooltipEl.style.color = 'white';
  tooltipEl.style.borderRadius = '5px';

  ethnicityTooltipTimeout = setTimeout(() => {
    tooltipEl.style.opacity = '0';
  }, 2500);

};
